import React from 'react'
import { Card, Switch } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { themeActions } from '../../../../store/slices/theme.slice'

const ThemeCard = () => {
    const dispatch = useDispatch()
    const themeMode = useSelector(state => state.theme?.mode || 'light')
    const isDarkMode = themeMode === 'dark'

    const handleToggle = checked => {
        dispatch(themeActions.setTheme(checked ? 'dark' : 'light'))
    }

    return (
        <Card title='Theme' bordered={false} className='mb-32'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span>Dark Mode</span>
                <Switch checked={isDarkMode} onChange={handleToggle} />
            </div>
        </Card>
    )
}

export default ThemeCard

